import * as moment from 'moment';

const DATEFORMAT_SERVER = 'YYYY-MM-DD HH:mm:ss';
const DATEFORMAT_WEB_ONLYDATE = 'DD/MM/YYYY';

export class DateUtils {

    static formatOnlyDate(date) {
        return moment(date, DATEFORMAT_SERVER).format(DATEFORMAT_WEB_ONLYDATE);
    }
}